import reduxStoreConfig from "./store";
export const { persistor, store } = reduxStoreConfig();
